<div class="flex items-center justify-between w-full space-x-4 bg-white p-2 rounded-xl">
  <span class="text-xl font-semibold">{{instance?.name}}</span>
  @if (showSearch) {
    <div class="relative w-full max-w-md transition-all duration-300">
      <input [(ngModel)]="searchTerm" type="text" [placeholder]="'DESCRIPTION.SEARCH_PLACEHOLDER' | translate"
        class="w-full pl-8 pr-8 py-1 border border-primary-800 rounded-full focus:outline-none focus:ring-2 focus:ring-primary-800 text-gray-500 placeholder:text-gray-200" />
      <div class="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500">
        <img src="../../../assets/search.png" class="h-3 w-3" />
      </div>
      <div class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer">
        <img src="../../../assets/group.png" class="h-4 w-4" (click)="showSearch = false" />
      </div>
    </div>
  }
  @if (!showSearch) {
    <div class="cursor-pointer bg-surface-card border-b-2 border-l-2 p-1 rounded-md"
      (click)="showSearch = true">
      <img src="../../../assets/search.png" class="h-4 w-4" />
    </div>
  }
</div>

<div class="border-b-[1px] py-2 font-bold grid grid-cols-12">
  <div class="col-span-8 text-sm">{{ 'DESCRIPTION.LABEL_DESCRIPTION' | translate }}</div>
  <div class="col-span-4 text-sm text-center">{{ 'DESCRIPTION.CREATION_DATE' | translate }}</div>
</div>
<div>
  <input *appAgentWritable type="text" [(ngModel)]="newDescription" (keydown.enter)="createDescription()"
    [placeholder]="'DESCRIPTION.ADD_DESCRIPTION' | translate"
    class="placeholder:text-gray-200 placeholder:text-sm mt-1 p-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-primary w-full" />
</div>
@if (showDescription) {
  <div class="w-full flex justify-center m-2">
    <div role="status">
      <app-loading-spinner class="w-6 h-6"></app-loading-spinner>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
}
@if (!showDescription) {
  <div class="mt-4">
    <div class="flex flex-wrap">
      @if (descriptions && descriptions.length > 0) {
        <div class="flex items-center m-2 space-x-2 ">
          <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelection($event)"
            class="appearance-none h-3 w-3 border border-gray-400 rounded-sm checked:bg-amber-800 checked:border-amber-800 relative cursor-pointer" />
          <label class="text-amber-800 cursor-pointer ml-2">Tout selectionner</label>
        </div>
      }
      <div class="flex-grow"></div>
      <div class="flex flex-row gap-2">
        <ng-container *appAgentWritable>
          @if (selectedIds.length > 0) {
            <button class="flex items-center bg-surface-muted rounded-md shadow-md border-2 p-1"
              (click)="openModal(5)">
              <app-icon-trash class="h-4 w-4"></app-icon-trash>
            </button>
          }
        </ng-container>
      </div>
    </div>
    <div class="w-full bg-white text-sm">
      @for (description of descriptions | filterBySearch: searchTerm; track description; let i = $index) {
        <div
          class="border-b-[1px] my-2 p-2 items-center hover:bg-gray-50 duration-100 cursor-pointer grid grid-cols-12">
          <div class="col-span-8 font-medium text-gray-800 space-x-2 flex flex-wrap">
            <input type="checkbox" [checked]="isSelected(description.id)" (change)="toggleSelection(description.id)"
              class="appearance-none h-3 w-3 border border-gray-400 rounded-sm checked:bg-amber-800 checked:border-amber-800 relative cursor-pointer" />
            <p>{{ description.details }}</p>
          </div>
          <div class="col-span-4  font-medium text-gray-800 text-center">
            {{ description.createdDate | friendlyDate}}
          </div>
        </div>
      }
      @if ((descriptions | filterBySearch:searchTerm)?.length === 0) {
        <div class="text-gray-400 p-4 text-center">
          {{ 'DESCRIPTION.NO_RESULTS' | translate }}.
        </div>
      }
    </div>
  </div>
}
@if (modalValue() === 5) {
  <app-modal>
    <div class="flex flex-col items-center text-center">
      <div class="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mb-4">
        <i class="fa-solid fa-xmark text-red-600 text-xl"></i>
      </div>
      <h2 class="text-lg font-semibold text-gray-800">Confirmation de suppression</h2>
      <p class="text-sm text-gray-600 mt-3 px-4">Êtes-vous sûr de vouloir supprimer
        <span class="font-semibold">{{ selectedIds.length }}</span> description(s) sélectionnée(s) ?
      </p>
      <div class="flex justify-end space-x-3 mt-6 w-full px-6">
        <button (click)="closeModal()"
          class="border border-gray-300 text-gray-700 px-6 py-2 rounded-md hover:bg-gray-100 transition">
          {{ 'MODAL.CANCEL' | translate }}
        </button>
        <button (click)="deleteDescriptions()"
          class="bg-primary text-white px-6 py-2 rounded-md hover:bg-red-700 transition">
          {{ 'MODAL.SUBMIT' | translate }}
        </button>
      </div>
    </div>
  </app-modal>
}